import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import IntelliProveUnsupportedBrowserError from '~errors/unsupported_browser';
import { useSettings } from '~providers/settings';
import { supportsES2020 } from '~utils/device';
import { getSearchParam } from '~utils/path/search_params';
import { applyTheming } from '~utils/theming';
import { SectionStore } from './stores/sections';

function AppSetup() {
  const { theming } = useSettings();

  useEffect(() => {
    // Compatibilty checks
    if (!supportsES2020()) {
      throw new IntelliProveUnsupportedBrowserError();
    }

    // sections
    const metrics = getSearchParam('metrics');
    const biomarkers = getSearchParam('biomarkers');
    const recommendations = getSearchParam('recommendations');
    const todos = getSearchParam('todos');
    const main = getSearchParam('main');
    SectionStore.setState({
      mainEnabled: main !== 'disabled', // Default ON
      metricsEnabled: metrics !== 'disabled', // Default ON
      biomarkersEnabled: biomarkers !== 'disabled', // Default ON
      recommendationsEnabled: recommendations === 'enabled', // Default OFF
      todosEnabled: todos === 'enabled', // Default ON
    });
  }, []);

  useEffect(() => {
    if (theming) applyTheming(theming);
  }, [theming]);

  return (
    <>
      <Outlet />
    </>
  );
}

export default AppSetup;
